/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Link } from 'react-router-dom'
import onClickOutside from 'react-onclickoutside'

/**
 *     Import
 *     - Components
 */
import config from '../../../api/configure'
import Container from '../../common/Container/Container'
import HeaderContainer from '../../common/HeaderContainer/HeaderContainer'
import ClientsTableHeader from './components/ClientsTableHeader'
import { ViewIcon } from '../../../images/icons/View/View'
// import { TickIcon } from '../../../images/icons/Tick/Tick'
import ToolTip from '../../common/ToolTip/ToolTip'
import { Button } from '../../common/Button/Button'
import Loading from '../../common/Loading/Loading'
import PopUp from '../../common/PopUp/PopUp'
import { Dropdown } from '../../common/Dropdown/Dropdown'

var EnhancedComponent = onClickOutside(Dropdown)
// import axios from "axios"
/**
 *     Import
 *     - CSS
 */
import './styles/Accounts.css'

/**
 * Accounts section class
 *
 * @export
 * @class Accounts
 * @extends {React.Component<any, any>}
 * 
 */
const minOffset = 0
const maxOffset = 60
const FutureminOffset = -25
const FuturemaxOffset = 0

const monthList = [
    { value: 1, text: 'January' },
    { value: 2, text: 'February' },
    { value: 3, text: 'March' },
    { value: 4, text: 'April' },
    { value: 5, text: 'May' },
    { value: 6, text: 'June' },
    { value: 7, text: 'July' },
    { value: 8, text: 'August' },
    { value: 9, text: 'September' },
    { value: 10, text: 'October' },
    { value: 11, text: 'November' },
    { value: 12, text: 'December' },
]

const thisYear = (new Date()).getFullYear()
const thisDay = (new Date()).getDate()
const thisMonth = (new Date()).getMonth()

export default class Accounts extends React.Component<any, any> {

    /**
     * Creates an instance of Clients.
     * @param {*} props
     * @memberof Clients
     */
    constructor(props: any) {
        super(props)
        this.state = {
            bodereux: false,
            thisYear: thisYear,
            selectedFromYear: thisYear,
            selectedFromDay: thisDay,
            selectedFromMonth: thisMonth,
            selectedToYear: thisYear,
            selectedToDay: thisDay,
            selectedToMonth: thisMonth,
            filters: {
                page: 1,
                perPage: 20,
                sortedBy: 'clientName',
                sortedType: 'asc',
            },
            confirmDeleteEntry: false,
            DeleteId: null,
            _generatePopup: false,
            _generateError: '',
        }
    }

    setGenerateDateStateInit = () => {
        this.setState({
            selectedFromYear: thisYear,
            selectedFromDay: thisDay,
            selectedFromMonth: thisMonth,
            selectedToYear: thisYear,
            selectedToDay: thisDay,
            selectedToMonth: thisMonth,
        })
    }

    /**
     * Will check the URL before the component mounts and will redirect
     * to the correct site of the application
     *
     * @memberof Clients
     */
    componentWillMount() {
        this.props.fetchAccountList()
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        if (this.state.filters !== nextState.filters) {
            this.props.fetchAccountList(
                nextState.filters.page,
                nextState.filters.perPage,
                nextState.filters.sortedBy,
                nextState.filters.sortedType
            )
        }
    }

    /**
     * Will handle the footer click for more data loading
     *
     * @memberof Clients
     */
    handleFooterClick = () => {
        this.setState({ filters: { perPage: this.state.filters.perPage + 20 } })
    }

    bordereux = () => {
        this.setState({ bodereux: true })
    }
    okBordereux = () => {
        this.setState({ bodereux: false })
        let bordereaux: any = {
            'bordereaux': {
                'from_date': {
                    'day': this.state.selectedFromDay,
                    'month': this.state.selectedFromMonth,
                    'year': this.state.selectedFromYear,
                },
                'to_date': {
                    'day': this.state.selectedToDay,
                    'month': this.state.selectedToMonth,
                    'year': this.state.selectedToYear,
                },
            },
        }
        this.props.generateborderaux(bordereaux).then((response) => {
            if (response) {
                this.setGenerateDateStateInit()
            }
        }).catch((response) => {
            if (response.error) {
                this.setState({
                    _generatePopup: true,
                    _generateError: response.error,
                })
            }
        })
    }
    cancelBordereux = () => {
        this.setState({ bodereux: false })
        this.setGenerateDateStateInit()
    }
    onFromChange = (evt, which) => {
        // Handle Change Here
        // alert(evt.target.value);
        // console.log(evt.target.value, which)
        switch (which) {
            case 'yr':
                this.setState({ selectedFromYear: Number(evt) })
                break

            case 'month':
                this.setState({ selectedFromMonth: Number(evt) })
                break

            case 'day':
                this.setState({ selectedFromDay: Number(evt) })
                break

            default:
                break
        }
    }
    onToChange = (evt, which) => {
        // Handle Change Here
        // alert(evt.target.value);
        switch (which) {
            case 'yr':
                this.setState({ selectedToYear: Number(evt) })
                break

            case 'month':
                this.setState({ selectedToMonth: Number(evt) })
                break

            case 'day':
                this.setState({ selectedToDay: Number(evt) })
                break

            default:
                break
        }
    }

    /**
     * Trigger fot the header filters
     *
     * @memberof Clients
     * @param {Object} params
     */
    filterTrigger = (params: any) => this.setState(
        {
            filters: {
                page: this.state.filters.page,
                perPage: this.state.filters.perPage,
                sortedBy: params.sortedBy,
                sortedType: params.sortedType,
            },
        }
    )

    markAsPaid = (paidId: any) => {
        this.props.mark_as_paid(paidId).then((response) => {
            if (response) {
                this.forceUpdate()
            }
        })
    }

    deleteEntry = (deleteId: any) => {
        this.setState({ confirmDeleteEntry: true, DeleteId: deleteId })
    }

    confirmDelete = () => {
        if (this.state.DeleteId) {
            this.props.remove_entry(this.state.DeleteId).then((response) => {
                if (response) {
                    this.forceUpdate()
                }
            }
            )
            this.setState({ confirmDeleteEntry: false })
        }
    }

    render() {
        const { generateBorderaux: { loading } } = this.props.accounts
        const { _generateError, _generatePopup } = this.state

        const { baseUrl } = config()
        let quotesCount = (this.props.accounts.accounts.done) ? this.props.accounts.accounts.response.totalNumber : 0

        const Yearoptions: any = []
        const FutureYearoptions: any = []
        let DayOptions: any = []

        for (let i = minOffset; i <= maxOffset; i++) {
            const year = thisYear - i
            let opt = { value: year, 'text': year }
            Yearoptions.push(opt)
        }
        for (let i = FuturemaxOffset; i >= FutureminOffset; i--) {
            const year = thisYear - i
            let opt = { value: year, 'text': year }
            FutureYearoptions.push(opt)
        }

        for (let k = 1; k <= 31; k++) {
            let _data: any = { value: k, 'text': k }
            DayOptions.push(_data)
        }

        return (
            <div className="accounts">
                {_generatePopup === true ? (
                    <PopUp
                        title={`GENERATE STATEMENT OF ACCOUNTS`}
                        buttonText={`Close`}
                        action={() => { this.setState({ _generatePopup: false, _generateError: '' }) }}
                    >
                        {(_generateError).toLowerCase()}
                    </ PopUp>
                ) : null}
                <HeaderContainer
                    className="accounts__header"
                    fullwidth={true}
                    titles={['accounts']}
                >
                    <div className="generate-statement">
                        <a href={`${baseUrl}/accounts/generate_statement`}>
                            GENERATE STATEMENT OF ACCOUNTS
                        </a>
                    </div>
                    <div className="bar__getquote generate_bordereux">
                        {(this.props.userSession.agentAdmin) ?
                            <a onClick={() => this.bordereux()}>
                                <span>
                                    Generate bordereau
                                </span>
                            </a> : null}
                        <div className="policyCount">
                            {`${quotesCount} ${(quotesCount === 1) ? 'policy' : 'policies'} due for payment`}
                        </div>
                    </div>

                </HeaderContainer>
                <ClientsTableHeader
                    state={this.state}
                    dataType={this.state.typeSelected}
                    filterTrigger={this.filterTrigger}
                />
                {loading ? (
                    <PopUp
                        title={`GENERATE STATEMENT OF ACCOUNTS`}
                        buttonText={`Loading`}
                        action={() => { '' }}
                    >
                        ...loading
                    </ PopUp>
                ) : null}
                {
                    (this.state.bodereux) ?
                        < PopUp
                            title="Generate Bordereau"
                            buttonText="Export Bordereau"
                            action={this.okBordereux}
                            numberButtons={2}
                            secondaryButtonText="Cancel"
                            secondaryAction={this.cancelBordereux}
                        >
                            <p>Please select the dates for which you wish to generate bordereau</p>
                            <form className="boderaux_form">

                                <div className="boderaux_form_group">
                                    <h4 className="boderaux_title">From</h4>
                                    <div className="boderaux_filed day_select">
                                        <div className="boderaux_select">
                                            <EnhancedComponent
                                                itemList={DayOptions}
                                                name="day"
                                                selected={[
                                                    thisDay,
                                                    thisDay,
                                                ]}
                                                setFieldValue={
                                                    (name, value) => this.onFromChange(value, name)
                                                }
                                                label="Day"
                                            />
                                        </div>
                                    </div>
                                    <div className="boderaux_filed month_select">
                                        <div className="boderaux_select">
                                            <EnhancedComponent
                                                itemList={monthList}
                                                name="month"
                                                selected={[
                                                    monthList[thisMonth].value,
                                                    monthList[thisMonth].text,
                                                ]}
                                                setFieldValue={
                                                    (name, value) => this.onFromChange(value, name)
                                                }
                                                label="Month"
                                            />
                                        </div>
                                    </div>
                                    <div className="boderaux_filed year_select">
                                        <div className="boderaux_select">
                                            <EnhancedComponent
                                                itemList={Yearoptions}
                                                name="yr"
                                                selected={[
                                                    thisYear,
                                                    thisYear,
                                                ]}
                                                setFieldValue={
                                                    (name, value) => this.onFromChange(value, name)
                                                }
                                                label="Year"
                                            />
                                        </div>
                                    </div>

                                </div>

                                <div className="boderaux_form_group">
                                    <h4 className="boderaux_title">To</h4>
                                    <div className="boderaux_filed day_select">
                                        <div className="boderaux_select">
                                            <EnhancedComponent
                                                itemList={DayOptions}
                                                name="day"
                                                selected={[
                                                    thisDay,
                                                    thisDay,
                                                ]}
                                                setFieldValue={
                                                    (name, value) => this.onToChange(value, name)
                                                }
                                                label="Day"
                                            />
                                        </div>
                                    </div>
                                    <div className="boderaux_filed month_select">
                                        <div className="boderaux_select">
                                            <EnhancedComponent
                                                itemList={monthList}
                                                name="month"
                                                selected={[
                                                    monthList[thisMonth].value,
                                                    monthList[thisMonth].text,
                                                ]}
                                                setFieldValue={
                                                    (name, value) => this.onToChange(value, name)
                                                }
                                                label="Month"
                                            />
                                        </div>
                                    </div>
                                    <div className="boderaux_filed year_select">
                                        <div className="boderaux_select">
                                            <EnhancedComponent
                                                itemList={FutureYearoptions}
                                                name="yr"
                                                selected={[
                                                    thisYear,
                                                    thisYear,
                                                ]}
                                                setFieldValue={
                                                    (name, value) => this.onToChange(value, name)
                                                }
                                                label="Year"
                                            />
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </ PopUp>
                        :
                        null
                }
                {(this.state.confirmDeleteEntry) ?
                    < PopUp
                        title="Confirm"
                        buttonText="Yes"
                        action={this.confirmDelete}
                        numberButtons={2}
                        secondaryButtonText="Cancel"
                        secondaryAction={() => this.setState({ confirmDeleteEntry: false })}
                    >
                        Are you sure?
                    </ PopUp> :
                    null}
                <Container className="accounts accounts__table table__content" fullwidth={false}>
                    {
                        (this.props.accounts.accounts.done &&
                            this.props.accounts.accounts.response.accounts.map((quote: any, i: number) => (
                                <div key={i}>
                                    <div className="table__row">
                                        <div className="column" />
                                        <div className="column no-margin">{quote.clientName}</div>
                                        <div className="column">{quote.inceptionDate}</div>
                                        <div className="column">{quote.policyNumber}</div>
                                        <div className="column">£{quote.premium}</div>
                                        <div className="column center">
                                            {(quote.paid) ?
                                                <div onClick={() => this.markAsPaid(quote.id)}>
                                                    <ToolTip
                                                        position="left"
                                                        verticalPosition="top"
                                                        Accounts={true}
                                                        AccountsBin={false}
                                                        paid={true}
                                                    >
                                                        Mark as not paid
                                                    </ToolTip>
                                                </div>
                                                :
                                                <div onClick={() => this.markAsPaid(quote.id)}>
                                                    <ToolTip
                                                        position="left"
                                                        verticalPosition="top"
                                                        Accounts={true}
                                                        AccountsBin={false}
                                                        paid={false}
                                                    >
                                                        Mark as paid
                                                    </ToolTip>
                                                </div>
                                            }
                                            {(quote.paid) ?
                                                <div onClick={() => this.deleteEntry(quote.id)}>
                                                    <ToolTip
                                                        position="left"
                                                        verticalPosition="top"
                                                        Accounts={true}
                                                        AccountsBin={true}
                                                    >
                                                        Remove from bordereaux
                                                    </ToolTip>
                                                </div>
                                                :
                                                <div>
                                                    <ToolTip
                                                        position="left"
                                                        verticalPosition="top"
                                                        Accounts={true}
                                                        AccountsBin={true}
                                                    >
                                                        Remove from bordereaux
                                                    </ToolTip>
                                                </div>}
                                            <div>
                                                <Link to={`/clients/policies/view/${quote.policyId}`}>
                                                    <ViewIcon />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                            ))
                    }
                </Container>
                <div className="accounts__footer">
                    <div className="accounts__footer--brick" >
                        {
                            (this.props.accounts.accounts.loading) ?
                                <Loading />
                                :
                                <Button type="submit" onClick={this.handleFooterClick}>Load more</Button>
                        }
                    </div>
                </div>
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Accounts/Accounts.tsx